import { Component, OnInit } from '@angular/core';
import { LmsUserService } from 'lms-api';

@Component({
  selector: 'app-landing-student',
  templateUrl: './landing-student.component.html',
  styleUrls: ['./landing-student.component.scss']
})
export class LandingStudentComponent implements OnInit {

  constructor(public lmsUserService: LmsUserService) { }

  ngOnInit() {
  }

}
